<template>
    <v-alert
        type="error"
        dismissible
        :style="hasAction ? { cursor: 'pointer' } : {}"
    >
        <div class="d-flex align-center" @click="handleClick">
            <span>{{ message }}</span>
            <v-tooltip v-if="hasAction" top>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" small class="ml-2">
                        mdi-open-in-new
                    </v-icon>
                </template>
                <span>Click to open</span>
            </v-tooltip>
        </div>
    </v-alert>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'

export default {
    name: 'Error',
    props: {
        errorId: String,
        message: String,
        actionType: {
            type: String,
            default: null,
        },
        actionPayload: {
            type: Object,
            default: null,
        },
    },
    data: () => ({
        timeout: null,
        close: true,
    }),
    computed: {
        hasAction() {
            return !!this.actionType
        },
    },
    mounted() {
        setTimeout(() => {
            this.$emit('closeError', this.errorId)
        }, 10000)
    },
    methods: {
        ...mapMutations(['updateErrorItems']),
        ...mapActions(['setPendingAction']),
        handleClick() {
            if (!this.hasAction) return
            this.setPendingAction({
                type: this.actionType,
                payload: this.actionPayload,
            })
            this.$emit('closeError', this.errorId)
        },
    },
}
</script>

<style></style>
